<div class="container" *transloco="let t">
  <div class="row my-4">
    <div class="col-12 col-lg-8 mb-4">
      <h1 class="my-4">CONDITIONS GÉNÉRALES D’UTILISATION</h1>
      <p>
        Dernière mise à jour : 7 août 2025
      </p>
      <p class="my-2">
        <strong>Notes</strong>:
      </p>
      <ul>
        <li>Ces conditions s'appliquent à tous les utilisateurs, également aux utilisateurs non connectés.</li>
        <li>Pour les utilisateurs connectés, notamment les organisateurs d'activités, <a [routerLink]="routes.publishTerms">les conditions de publication</a> s'appliquent également.</li>
        <li>Voir aussi notre <a [routerLink]="routes.privacy">politique de confidentialité</a>.</li>
      </ul>

      <section>
        <h3>1. Présentation</h3>
        <p>
          Les présentes conditions générales d'utilisation (ci-après "CGU") régissent l’accès et l’utilisation de l’application {{ appName }}, accessible au domaine internet {{ domain }} (ci-après "l’Application").
        </p>
        <p>
          L’Application est éditée par l'Association P.H.A.R.E. (Promotion des Hobbies, Activités Régionales et Événements), association à but non lucratif régie par le droit suisse, dont le siège se situe à 2035 Corcelles (ci-après "l’Association").
        </p>
      </section>

      <section>
        <h3>2. Objet de l'application</h3>
        <p>
          L'Application permet aux utilisateurs de rechercher des activités de loisir en Suisse proposées par des tiers (associations, entreprises ou particuliers).
        </p>
        <p>
          Elle agit comme un intermédiaire d'information entre les organisateurs d'activités et la population.
        </p>
      </section>

      <section>
        <h3>3. Conditions d'accès et d'utilisation</h3>
        <ul>
          <li>L'accès à l'Application est gratuit.</li>
          <li>La consultation des activités ne nécessite pas la création d’un compte.</li>
          <li>Toutefois, la création d’un compte pourra être exigée pour certaines fonctionnalités, telles que la prise de contact avec un organisateur.</li>
          <li>L'utilisateur s’engage à utiliser l’Application de manière loyale, conformément aux lois suisses, et dans le respect de sa finalité, à savoir : la recherche ou la consultation d’activités de loisir en Suisse proposées par des tiers.</li>
          <li>Toute utilisation de l’Application à des fins étrangères à cette finalité (ex. prospection commerciale, extraction automatisée de données, diffusion de contenu non lié aux loisirs) est interdite et pourra donner lieu à des mesures restrictives (blocage d’accès, poursuites, etc.).</li>
        </ul>
      </section>

      <section>
        <h3>4. Contenu proposé</h3>
        <p>Les activités proposées sur l’Application peuvent provenir de plusieurs sources :</p>
        <ul>
          <li>En général, le contenu est proposé par des tiers (utilisateurs connectés) qui publient leurs propres activités;</li>
          <li>L’Association peut également publier elle-même certaines activités, notamment à partir d’informations disponibles publiquement, dans le but d’assurer une offre de contenu minimale ou représentative.</li>
        </ul>
        <p>
          Bien que l’Association fasse tout son possible pour vérifier les informations publiées, aucune garantie ne peut être apportée quant à leur exactitude, leur exhaustivité ou leur actualité. Une mention explicite "Les informations sont fournies sans garantie." ou similaire est affichée sur chaque publication.
        </p>
        <p>
          En cas de doute ou de problème concernant une activité, les utilisateurs peuvent contacter l’Association par email à l’adresse fournie dans l’Application.
          Un système de signalement dédié pourrait être mis en place ultérieurement.
        </p>
      </section>

      <section>
        <h3>5. Responsabilité</h3>
        <ul>
          <li>L’Association n’est pas l’organisatrice des activités publiées sur l’Application.</li>
          <li>L'association ne peut être tenue responsable en cas d’erreur, d'annulation, de litige ou d'incident survenu dans le cadre d'une activité publiée.</li>
          <li>La responsabilité du contenu et de l'organisation revient exclusivement à l'organisateur ayant proposé l'activité.</li>
          <li>En cas de doute, les utilisateurs sont invités à contacter directement l'organisateur.</li>
        </ul>

      </section>

      <section>
        <h3>6. Modération</h3>

        <p>Seules les activités de loisirs sont acceptées.</p>
        <p>Les activités à caractère politique, religieux, commercial non lié au loisir, discriminatoire ou contraire à la mission de l’Application seront en principe refusées.</p>
        <p>
          L’Association se réserve également le droit de modifier ou de supprimer tout contenu, à tout moment et sans préavis, y compris après sa publication, sans avoir à motiver sa décision.
          Cette modération vise à garantir la qualité, la cohérence et la sécurité du contenu proposé aux utilisateurs.
        </p>
      </section>

      <section>
        <h3>7. Propriété intellectuelle</h3>
        <ul>
          <li>Le design, le logo, le code et l’identité visuelle de l’Application sont la propriété exclusive de l’Association.</li>
          <li>
            Le contenu des activités (textes, images) reste la propriété de leur auteur. Toutefois, l’Association se réserve le droit :
            <ul>
              <li>d’en modifier ou supprimer tout ou partie, sans préavis ;</li>
              <li>de les utiliser à des fins de référencement (SEO) ou de communication interne et externe (réseaux sociaux, supports de présentation, newsletters, etc.), avec ou sans adaptation ;</li>
              <li>d’en autoriser le partage public non commercial, notamment via des boutons de partage vers les réseaux sociaux.</li>
            </ul>
          </li>
        </ul>

        <p>Seules les activités de loisirs en présentiel sont acceptées.</p>
        <p>Les activités à caractère politique, religieux, commercial non lié aux loisirs, discriminatoire ou contraire à la mission de l’Application seront en principe refusés.</p>
        <p>
          L’Association se réserve également le droit de modifier ou de supprimer tout contenu, à tout moment et sans préavis, y compris après sa publication, sans avoir à motiver sa décision.
          Cette modération vise à garantir la qualité, la cohérence et la sécurité du contenu proposé aux utilisateurs.
        </p>
      </section>

      <section>
        <h3>8. Protection des données</h3>
        <ul>
          <li>L’Application ne collecte pas de données personnelles pour la simple consultation.</li>
          <li>Des statistiques d’usage anonymes pourront être générées à des fins d’amélioration du service (ex. nombre de recherches, clics, prises de contact).</li>
          <li>Les données sont hébergées exclusivement en Suisse.</li>
          <li>L’Application est conforme à la nLPD (Nouvelle Loi fédérale sur la protection des données).</li>
        </ul>
      </section>

      <section>
        <h3>9. Modifications des CGU</h3>
        <p>L’Association se réserve le droit de modifier les présentes CGU à tout moment.</p>
        <p>La version applicable est celle publiée sur l’Application à la date d’utilisation.</p>
      </section>

      <section>
        <h3>10. Droit applicable et juridiction compétente</h3>
        <p>Les présentes CGU sont régies par le droit suisse.</p>
        <p>Tout litige relatif à l’utilisation de l’Application relève de la compétence exclusive des tribunaux de Neuchâtel en Suisse.</p>
      </section>

      <section>
        <h3>11. Langue applicable</h3>
        <p>L’Application peut être disponible en plusieurs langues.</p>
        <p>En cas de divergence entre les versions, la version française fait foi.</p>
      </section>
    </div>
  </div>
</div>
